<template>
  <transition name="ei-fade">
    <div
      v-if="open"
      class="ei-overlay"
      @click.self="close"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ei-title"
    >
      <transition name="ei-pop" appear>
        <section v-if="open" class="ei-modal">
          <!-- ============== HEADER ============== -->
          <header class="ei-header">
            <div class="ei-header__main">
              <span class="ei-eyebrow">§ 15 VersVermV</span>
              <h2 id="ei-title" class="ei-title">
                <span>Erstinformationen</span> für Kunden
              </h2>
              <p class="ei-sub">
                Pflichtangaben der <b>WaizmannTabelle GmbH</b> als unabhängiger
                Versicherungsmakler &mdash; gemäß § 15 der
                Versicherungsvermittlungsverordnung.
              </p>
            </div>
            <button
              type="button"
              class="ei-close"
              @click="close"
              aria-label="Erstinformationen schließen"
            >
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 1 0 5.7 7.11L10.59 12 5.7 16.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"
                />
              </svg>
            </button>
          </header>

          <!-- ============== BODY ============== -->
          <div class="ei-body">
            <!-- INTRO -->
            <article class="ei-intro">
              <p>
                Die WaizmannTabelle wird von der
                <strong>WaizmannTabelle GmbH</strong> (unabhängiger
                Versicherungsmakler) betrieben. Die WaizmannTabelle GmbH ist
                ein <strong>Familienbetrieb mit Sitz in München</strong> und
                wurde 1995 gegründet.
              </p>
              <p>
                Wir beschäftigen uns ausschließlich mit der Analyse und
                Bewertung von Zahnzusatzversicherungen. Mittlerweile sind wir
                die <strong>Nr. 1 in Deutschland</strong> im Bereich der
                Zahnzusatzversicherungen und werden von mehr als
                <strong>10.000 Zahnärzten</strong> regelmäßig empfohlen.
              </p>
            </article>

            <!-- GRID: Kontakt + Geschäftsführung + Tätigkeit -->
            <div class="ei-grid">
              <article class="ei-block">
                <span class="ei-block__tag">Kontakt</span>
                <h3 class="ei-block__h">So erreichen Sie uns</h3>
                <dl class="ei-dl">
                  <dt>Web</dt>
                  <dd>
                    <a href="https://www.waizmanntabelle.de" target="_blank" rel="noopener">
                      www.waizmanntabelle.de
                    </a>
                  </dd>
                  <dt>Telefon</dt>
                  <dd>089-31868310</dd>
                  <dt>Fax</dt>
                  <dd>089-3162218</dd>
                  <dt>E-Mail</dt>
                  <dd>
                    <a href="mailto:info@waizmanntabelle.de">info@waizmanntabelle.de</a>
                  </dd>
                </dl>
                <h4 class="ei-block__sub">Postanschrift</h4>
                <address class="ei-addr">
                  WaizmannTabelle GmbH<br />
                  Ludwig-Ganghofer-Straße 6<br />
                  82031 Grünwald
                </address>
              </article>

              <article class="ei-block">
                <span class="ei-block__tag">Geschäftsführung</span>
                <h3 class="ei-block__h">Verantwortlich</h3>
                <h4 class="ei-block__sub">Geschäftsführung WaizmannTabelle</h4>
                <p class="ei-block__p">Florian Meier</p>
                <h4 class="ei-block__sub">Geschäftsführung Versicherungsvermittlung</h4>
                <p class="ei-block__p">
                  WaizmannTabelle GmbH<br />
                  Florian Meier
                </p>
                <h4 class="ei-block__sub">Gesellschafter</h4>
                <p class="ei-block__p">Florian Meier</p>
              </article>

              <article class="ei-block">
                <span class="ei-block__tag">Tätigkeit</span>
                <h3 class="ei-block__h">Art der Versicherungstätigkeit</h3>
                <p class="ei-block__p">
                  Die <strong>WaizmannTabelle GmbH</strong> ist gemäß
                  <strong>§ 93 HGB</strong> als Makler tätig.
                </p>
                <h4 class="ei-block__sub">Finanzierung</h4>
                <p class="ei-block__p">
                  Unsere Service-Leistungen sind für Kunden
                  <strong>kostenlos</strong>. Wir erhalten von den meisten
                  angeschlossenen Versicherungen eine Abschluss-Vergütung. Diese
                  hat <b>keinen Einfluss</b> auf das Ranking und den
                  WaizmannWert.
                </p>
                <h4 class="ei-block__sub">Beteiligungen</h4>
                <p class="ei-block__p">
                  Die WaizmannTabelle GmbH besitzt keine direkten oder
                  indirekten Beteiligungen oder Stimmrechte am Kapital eines
                  Versicherungsunternehmens &mdash; und umgekehrt.
                </p>
              </article>
            </div>

            <!-- GRID: Vermittlerregister + Berufshaftpflicht -->
            <div class="ei-grid ei-grid--2">
              <article class="ei-block ei-block--accent">
                <span class="ei-block__tag">Registrierung</span>
                <h3 class="ei-block__h">Vermittlerregister</h3>
                <p class="ei-block__p">
                  Die WaizmannTabelle GmbH ist
                  <strong>Versicherungsmakler mit Erlaubnis</strong> gemäß
                  § 34 d Abs. 1 GewO.
                </p>
                <div class="ei-fact">
                  <span class="ei-fact__l">IHK-Nr.</span>
                  <span class="ei-fact__v">D-AZHX-QKS5Z-54</span>
                </div>
              </article>

              <article class="ei-block ei-block--accent">
                <span class="ei-block__tag">Absicherung</span>
                <h3 class="ei-block__h">Berufshaftpflicht</h3>
                <p class="ei-block__p">
                  Eine den Bestimmungen der EU-Vermittlerrichtlinie entsprechende
                  Berufshaftpflicht- bzw. Vermögensschadenhaftpflichtversicherung
                  liegt vor.
                </p>
                <div class="ei-fact">
                  <span class="ei-fact__l">Versicherer</span>
                  <span class="ei-fact__v">Nassau Versicherungen</span>
                </div>
              </article>
            </div>

            <!-- AUFSICHT & SCHLICHTUNG -->
            <h3 class="ei-section-h">Aufsicht &amp; Schlichtungsstellen</h3>
            <div class="ei-grid">
              <article class="ei-block">
                <span class="ei-block__tag">Aufsicht</span>
                <h3 class="ei-block__h">IHK München &amp; Oberbayern</h3>
                <address class="ei-addr">
                  Max-Joseph-Str. 2<br />
                  80333 München<br /><br />
                  Tel.: 089-5116-0<br />
                  Fax: 089-5116-306<br />
                  <a href="mailto:iszihkmail@muenchen.ihk.de">iszihkmail@muenchen.ihk.de</a><br />
                  <a href="https://www.ihk-muenchen.de" target="_blank" rel="noopener">www.ihk-muenchen.de</a>
                </address>
              </article>

              <article class="ei-block">
                <span class="ei-block__tag">BAFin</span>
                <h3 class="ei-block__h">Bundesanstalt f. Finanzdienstleistungs­aufsicht</h3>
                <address class="ei-addr">
                  Graurheindorfer Straße 108<br />
                  53117 Bonn<br /><br />
                  Tel.: 0228-4108-0<br />
                  Fax: 0228-4108-1550<br />
                  <a href="https://www.bafin.de" target="_blank" rel="noopener">www.bafin.de</a>
                </address>
              </article>

              <article class="ei-block">
                <span class="ei-block__tag">Schlichtung</span>
                <h3 class="ei-block__h">Versicherungsombudsmann e.V.</h3>
                <address class="ei-addr">
                  Postfach 080622<br />
                  10006 Berlin<br /><br />
                  Tel.: 01804-224424<br />
                  Fax: 01804-224425<br />
                  <a href="https://www.versicherungsombudsmann.de" target="_blank" rel="noopener">www.versicherungsombudsmann.de</a>
                </address>
              </article>

              <article class="ei-block ei-block--full">
                <span class="ei-block__tag">PKV-Ombudsmann</span>
                <h3 class="ei-block__h">
                  Ombudsmann für die private Kranken- und Pflegeversicherung
                </h3>
                <address class="ei-addr">
                  Leipziger Str. 104, 10117 Berlin
                  &nbsp;&middot;&nbsp; Tel.: 01802-550444
                  &nbsp;&middot;&nbsp; Fax: 030-20458931
                  &nbsp;&middot;&nbsp;
                  <a href="https://www.pkv-ombudsmann.de" target="_blank" rel="noopener">www.pkv-ombudsmann.de</a>
                </address>
              </article>
            </div>
          </div>

          <!-- ============== FOOTER ============== -->
          <footer class="ei-footer">
            <span class="ei-footer__note">
              Stand: laufend aktualisiert &middot; WaizmannTabelle GmbH
            </span>
            <div class="ei-footer__actions">
              <button
                type="button"
                class="ei-btn ei-btn--ghost"
                @click="printPage"
              >
                <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                  <path
                    fill="currentColor"
                    d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
                  />
                </svg>
                Drucken / als PDF speichern
              </button>
              <button type="button" class="ei-btn ei-btn--primary" @click="close">
                Schließen
                <span class="ei-arrow" aria-hidden="true">→</span>
              </button>
            </div>
          </footer>
        </section>
      </transition>
    </div>
  </transition>
</template>

<script setup>
import { defineProps, defineEmits, watch, onUnmounted } from "vue";

const props = defineProps({
  open: { type: Boolean, default: false },
});
const emit = defineEmits(["close", "update:open"]);

function close() {
  emit("close");
  emit("update:open", false);
}

function printPage() {
  if (typeof window !== "undefined") window.print();
}

function onKey(e) {
  if (e.key === "Escape" && props.open) close();
}

watch(
  () => props.open,
  (v) => {
    if (typeof document === "undefined") return;
    if (v) {
      document.body.style.overflow = "hidden";
      document.addEventListener("keydown", onKey);
    } else {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKey);
    }
  },
  { immediate: true }
);

onUnmounted(() => {
  if (typeof document !== "undefined") {
    document.body.style.overflow = "";
    document.removeEventListener("keydown", onKey);
  }
});
</script>

<style scoped>
/* ===== Overlay ===== */
.ei-overlay {
  position: fixed;
  inset: 0;
  z-index: 90;
  background: rgba(10, 30, 60, 0.45);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

/* ===== Modal ===== */
.ei-modal {
  width: 100%;
  max-width: 1040px;
  max-height: calc(100vh - 48px);
  background: #fff;
  border: 2px solid var(--wt-blue-deep, #1a3d6b);
  border-radius: 0;
  box-shadow:
    0 30px 60px rgba(10, 30, 60, 0.32),
    0 8px 18px rgba(10, 30, 60, 0.12);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: var(--wt-text, #2a2a2a);
  font-family: inherit;
}

/* ===== Header ===== */
.ei-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 22px 28px 18px;
  background: linear-gradient(135deg, #2c5b9e 0%, #1a3d6b 100%);
  color: #fff;
  position: relative;
}
.ei-header::after {
  content: "";
  position: absolute;
  left: 0; right: 0; bottom: 0;
  height: 4px;
  background: var(--wt-yellow, #fecf0c);
}

.ei-header__main { flex: 1; min-width: 0; }
.ei-eyebrow {
  display: inline-block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: var(--wt-yellow, #fecf0c);
  margin-bottom: 6px;
}
.ei-title {
  margin: 0;
  font-size: 26px;
  font-weight: 900;
  line-height: 1.15;
  color: #fff !important;
  letter-spacing: -0.4px;
}
.ei-title span { color: var(--wt-yellow, #fecf0c); font-weight: 900; }
.ei-sub {
  margin: 8px 0 0;
  font-size: 13.5px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.88);
  max-width: 720px;
}
.ei-sub b { color: #fff; font-weight: 700; }

.ei-close {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 0;
  cursor: pointer;
  transition: background 0.15s ease;
}
.ei-close:hover { background: rgba(255, 255, 255, 0.26); }
.ei-close:focus-visible { outline: 2px solid var(--wt-yellow, #fecf0c); outline-offset: 2px; }

/* ===== Body ===== */
.ei-body {
  flex: 1;
  overflow-y: auto;
  padding: 26px 28px 30px;
  background: #fafbfd;
}

.ei-intro {
  max-width: 80ch;
  margin: 0 0 22px;
}
.ei-intro p {
  margin: 0 0 12px;
  font-size: 15px;
  line-height: 1.7;
  color: var(--wt-text, #2a2a2a);
}
.ei-intro strong { color: var(--wt-blue-deep, #1a3d6b); font-weight: 700; }

/* ===== Section heading inside body ===== */
.ei-section-h {
  margin: 26px 0 12px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: var(--wt-blue-deep, #1a3d6b);
  padding-bottom: 6px;
  border-bottom: 1px solid var(--wt-blue-line, #d8e2ee);
}

/* ===== Grid ===== */
.ei-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}
.ei-grid--2 {
  grid-template-columns: repeat(2, 1fr);
  margin-top: 14px;
}

.ei-block {
  background: #fff;
  border: 1px solid var(--wt-blue-line, #d8e2ee);
  border-top: 3px solid var(--wt-blue, #2c5b9e);
  padding: 18px 20px 20px;
  display: flex;
  flex-direction: column;
}
.ei-block--full { grid-column: 1 / -1; }
.ei-block--accent {
  border-top-color: var(--wt-yellow, #fecf0c);
  background: #fffdf5;
}

.ei-block__tag {
  display: inline-block;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: var(--wt-blue-deep, #1a3d6b);
  margin-bottom: 8px;
}
.ei-block--accent .ei-block__tag {
  color: #8a6800;
}

.ei-block__h {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 800;
  color: var(--wt-ink, #0a0a0a);
  line-height: 1.25;
  letter-spacing: -0.1px;
}

.ei-block__sub {
  margin: 14px 0 4px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--wt-blue-deep, #1a3d6b);
}
.ei-block__sub:first-of-type { margin-top: 4px; }

.ei-block__p {
  margin: 0 0 6px;
  font-size: 13.5px;
  line-height: 1.6;
  color: var(--wt-text, #2a2a2a);
}
.ei-block__p strong { color: var(--wt-blue-deep, #1a3d6b); font-weight: 700; }

/* ===== Definition list (Kontakt) ===== */
.ei-dl {
  display: grid;
  grid-template-columns: 70px 1fr;
  gap: 4px 12px;
  margin: 0 0 4px;
  font-size: 13.5px;
}
.ei-dl dt {
  font-size: 10.5px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--wt-muted, #6a7a90);
  padding-top: 3px;
}
.ei-dl dd {
  margin: 0;
  color: var(--wt-text, #2a2a2a);
  word-break: break-word;
}

/* ===== Address ===== */
.ei-addr {
  font-style: normal;
  font-size: 13.5px;
  line-height: 1.6;
  color: var(--wt-text, #2a2a2a);
  margin: 0;
}

/* ===== Links ===== */
.ei-block a,
.ei-addr a,
.ei-dl dd a {
  color: var(--wt-blue-deep, #1a3d6b);
  text-decoration: none;
  border-bottom: 1px solid currentColor;
  transition: color 0.15s ease;
}
.ei-block a:hover,
.ei-addr a:hover,
.ei-dl dd a:hover { color: var(--wt-blue, #2c5b9e); }

/* ===== Fact rows (IHK / Versicherer) ===== */
.ei-fact {
  margin-top: auto;
  padding-top: 12px;
  display: flex;
  align-items: baseline;
  gap: 10px;
  border-top: 1px dashed var(--wt-blue-line, #d8e2ee);
}
.ei-fact__l {
  font-size: 10.5px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--wt-muted, #6a7a90);
}
.ei-fact__v {
  font-size: 15px;
  font-weight: 800;
  color: var(--wt-blue-deep, #1a3d6b);
  font-feature-settings: "tnum" 1, "lnum" 1;
}

/* ===== Footer ===== */
.ei-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 22px;
  background: #fff;
  border-top: 1px solid var(--wt-blue-line, #d8e2ee);
}
.ei-footer__note {
  font-size: 11.5px;
  letter-spacing: 0.4px;
  color: var(--wt-muted, #6a7a90);
}
.ei-footer__actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.ei-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.2px;
  border-radius: 0;
  cursor: pointer;
  border: 2px solid transparent;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease,
    transform 0.05s ease;
  font-family: inherit;
  text-decoration: none;
}
.ei-btn:active { transform: translateY(1px); }
.ei-btn--ghost {
  background: #fff;
  color: var(--wt-blue-deep, #1a3d6b);
  border-color: var(--wt-blue-line, #d8e2ee);
}
.ei-btn--ghost:hover {
  border-color: var(--wt-blue, #2c5b9e);
  color: var(--wt-blue, #2c5b9e);
}
.ei-btn--primary {
  background: var(--wt-blue, #2c5b9e);
  color: #fff !important;
  border-color: var(--wt-blue, #2c5b9e);
}
.ei-btn--primary:hover {
  background: var(--wt-blue-deep, #1a3d6b);
  border-color: var(--wt-blue-deep, #1a3d6b);
}
.ei-arrow {
  display: inline-block;
  transition: transform 0.18s ease;
}
.ei-btn--primary:hover .ei-arrow { transform: translateX(3px); }

/* ===== Transitions ===== */
.ei-fade-enter-active,
.ei-fade-leave-active { transition: opacity 0.18s ease; }
.ei-fade-enter-from,
.ei-fade-leave-to { opacity: 0; }

.ei-pop-enter-active { transition: transform 0.22s ease, opacity 0.22s ease; }
.ei-pop-leave-active { transition: transform 0.16s ease, opacity 0.16s ease; }
.ei-pop-enter-from { transform: translateY(12px) scale(0.98); opacity: 0; }
.ei-pop-leave-to   { transform: translateY(8px)  scale(0.98); opacity: 0; }

/* ===== Responsive ===== */
@media (max-width: 900px) {
  .ei-grid,
  .ei-grid--2 { grid-template-columns: repeat(2, 1fr); }
  .ei-title { font-size: 22px; }
}
@media (max-width: 720px) {
  .ei-overlay { padding: 0; }
  .ei-modal {
    max-width: 100%;
    max-height: 100vh;
    border-width: 0;
  }
  .ei-header { padding: 18px 18px 14px; }
  .ei-title { font-size: 20px; }
  .ei-sub { font-size: 12.5px; }
  .ei-body { padding: 18px 16px 22px; }
  .ei-grid,
  .ei-grid--2 { grid-template-columns: 1fr; }
  .ei-section-h { margin-top: 22px; }
  .ei-footer {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 8px;
    padding: 12px 16px;
  }
  .ei-footer__actions { width: 100%; }
  .ei-btn { flex: 1; justify-content: center; padding: 12px 14px; }
  .ei-footer__note { text-align: center; font-size: 11px; }
}

/* ===== Print: render full Erstinformation as document ===== */
@media print {
  .ei-overlay {
    position: static;
    background: #fff;
    padding: 0;
  }
  .ei-modal {
    box-shadow: none;
    border: 0;
    max-height: none;
  }
  .ei-header {
    background: #fff !important;
    color: var(--wt-blue-deep, #1a3d6b) !important;
    border-bottom: 2px solid var(--wt-blue-deep, #1a3d6b);
  }
  .ei-header::after { display: none; }
  .ei-title,
  .ei-title span { color: var(--wt-blue-deep, #1a3d6b) !important; }
  .ei-eyebrow { color: var(--wt-blue, #2c5b9e); }
  .ei-sub { color: #333; }
  .ei-close,
  .ei-footer { display: none; }
  .ei-body { background: #fff; overflow: visible; }
  .ei-block { break-inside: avoid; page-break-inside: avoid; }
}
</style>
